import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { routePath } from "../../constants/routePath";
import { GetUserApi } from "../../utils/utils";
import {
  setchangeRoll,
  setSwitchAccount,
  setUserDetail,
} from "../../app/store/reducer";
import { useNavigate } from "react-router";

export default function AccountSwitcherModal({ open, onClose }) {
  // const accounts = JSON.parse(localStorage.getItem("accounts")) || [];
  const switchAccount = useSelector((state) => state.reducer.switchAccount);
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const handleSwitch = (account) => {
  //   // Set token for switched account
  //   sessionStorage.setItem("smbToken", account.token);

  //   // Set active account
  //   localStorage.setItem("activeAccount", account.mobile);

  //   // Reload app
  //   window.location.reload();
  // };
   const [accounts, setAccounts] = useState(
     JSON.parse(localStorage.getItem("accounts")) || [],
   );
  const handleSwitch = async (account) => {
    try {
      // Set token
      sessionStorage.setItem("smbToken", account.token);
      localStorage.setItem("activeAccount", account.mobile);

      // Fetch user again
      const userRes = await GetUserApi();
      const userData = userRes?.data?.data;
     
      // Update redux
      dispatch(setUserDetail(userData));
      dispatch(setchangeRoll("dashboard"));

      // Navigate properly
      if (userData?.appMenu === "Biller") {
        navigate(routePath.DASHBOARD);
      } else {
        navigate("/");
      }

      dispatch(setSwitchAccount(false));
    } catch (error) {
      console.error("Switch error:", error);
      Swal.fire({
        text: "Failed to switch account",
        icon: "error",
        ...swalAlertPopProps,
      });
    }
  };

  const handleDeleteAccount = (mobile) => {
   
   Swal.fire({
     title: "Remove Account?",
     text: "This account will be removed from this device.",
     icon: "warning",
     showCancelButton: true,
     confirmButtonText: "Yes, remove it",
     ...swalAlertPopProps,
   }).then((result) => {
    //  if (!result.isConfirmed) return;

     const activeAccount = localStorage.getItem("activeAccount");

     const updatedAccounts = accounts.filter((acc) => acc.mobile !== mobile);

     localStorage.setItem("accounts", JSON.stringify(updatedAccounts));

     setAccounts(updatedAccounts); // now works

     if (activeAccount === mobile) {
       sessionStorage.removeItem("smbToken");
       localStorage.removeItem("activeAccount");
       navigate("/login");
     }

     console.log("Before:", accounts);
     console.log("Deleting:", mobile);
     console.log("After:", updatedAccounts);
   });
  };
  // useEffect(() => {
  //   if (switchAccount) {
  //     const latestAccounts = JSON.parse(localStorage.getItem("accounts")) || [];
  //     setAccounts(latestAccounts);
  //   }
  // }, [switchAccount]);
  return (
    <Modal open={switchAccount} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: isMobile ? "50%" : "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          maxHeight: { xs: "90vh", sm: "80vh" },
          overflowY: "auto",
          bgcolor: "background.paper",
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{ mb: 2, textAlign: { xs: "center", sm: "left" } }}
        >
          Switch Account
        </Typography>

        {/* <List>
          {accounts.map((acc, index) => (
            <ListItem key={index} sx={{ px: 0 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleSwitch(acc)}
              >
                {acc?.userData?.name}
              </Button>
            </ListItem>
          ))}
        </List> */}
        <List>
          {accounts.map((acc, index) => (
            <ListItem
              key={index}
              sx={{
                px: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              {/* Switch Button */}
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleSwitch(acc)}
              >
                {acc?.userData?.name}
              </Button>

              {/* Delete Button */}
              <Button
                variant="contained"
                color="error"
                sx={{ minWidth: "40px", px: 1 }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent switching

                  handleDeleteAccount(acc.mobile);
                }}
              >
                −
              </Button>
            </ListItem>
          ))}
        </List>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => {
            localStorage.removeItem("activeAccount");
            // sessionStorage.clear();
            localStorage.setItem("isAddingAccount", "true");
            window.location.href = "/login";
          }}
        >
          + Add New Account
        </Button>
      </Box>
    </Modal>
  );
}
